/* eslint-disable complexity */
import React, { useCallback, useRef, useState } from "react";
import "./index.less";
import { WorkUserInfo } from "@/types/work";
import { Button, message, Popover, Progress, Tabs, Tooltip } from "antd";
import { useTranslation } from "react-i18next";
import prompt from "@/baseComponents/ModalComponent/prompt";
import { UserListEmptyImg } from "@/assets/img";
import { UserCardType } from "@/types/UserCard";
import { connect } from "dva";
import Bus from "@/utils/bus";
import { PROCESS_STATUS, processStatusOptions, TASK_STATUS } from "@/types/newWork";
import IconFont, { IconArrowLeft } from "@/components/icon";
import { EsuperviseSourceType, ICreateSuperviseData, Receiver, User } from "@/types/supervise";
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import { Avatar } from "@/baseComponents/Avatar";
import { changeEgovUrl } from "@/utils/tools";

import { ResStatus } from "@/api/calendar";
import { tagsNode } from "@/components/Joyspace/contextModal/AddMembers/baseComponents/Item";
import AdvanceCom from "@/components/Work/TaskDetailDraw/components/AdvanceCom";
import { checkWhenDeleteTaskExcutors } from "@/api/work";
import WorkUserListWeight, {
  number2percentum
} from "@/components/Work/BaseComponents/WorkUserListWeightSet";
import { PROCESS_STATUS_EXECUTORS } from "@/components/Projects/emnu";
import noDataPicture from "@/assets/img/no-content.png";
import { analysisLog } from "@/utils/logAnalytics";
import { getSuperviseReceiverList } from "@/api/supervise";
import LoadMore from "@/components/Supervise/components/loadMore";
import { isNumber } from "lodash";
/*
 * 待处理事项 1.埋点
 */
const { TabPane } = Tabs;

enum readTab {
  Read = "1",
  unRead = "2"
}

function UserStatusListPopover({
  popoverName,
  list,
  userPopover,
  userPopoverText,
  children,
  onRemove,
  openCreateSuperviseModal,
  disable,
  isHead = true,
  isQueryAuditList,
  userCardVisible,
  userData,
  taskDetail,
  mode,
  disableUserCard,
  listObj,
  isTaskRelatedPersonnel,
  handleTaskMembersWeight,
  notPersonalCalendar,
  showAdvance = false,
  visibleWeight = false,
  superviseId,
  superviseUnFinishCount,
  superviseFinishCount,
  supervisePopoverVisibleChange,
  superviseRepeat
}: {
  popoverName: string;
  list: WorkUserInfo[];
  userPopover: string;
  userPopoverText: string;
  children: any;
  onRemove: (user: any[] | User) => void;
  openCreateSuperviseModal: (opt: { visible: boolean; createData: ICreateSuperviseData }) => void;
  disable?: boolean;
  isHead?: boolean;
  isQueryAuditList?: boolean;
  userCardVisible?: boolean;
  userData: any;
  taskDetail: any;
  mode?: string;
  disableUserCard?: boolean;
  listObj: any;
  isTaskRelatedPersonnel?: boolean;
  handleTaskMembersWeight?: Function;
  notPersonalCalendar?: boolean;
  showAdvance?: boolean;
  visibleWeight?: boolean;
  superviseId?: string;
  superviseUnFinishCount?: number;
  superviseFinishCount?: number;
  supervisePopoverVisibleChange?: (v: boolean) => void;
  superviseRepeat?: () => void;
}) {
  const { t } = useTranslation("common");
  const [visible, setVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  // 任务的
  const [advanceVisible, setAdvanceVisible] = useState(false);
  const [advanceUser, setAdvanceUser] = useState<WorkUserInfo>();
  const [visibleOfWeight, setVisibleOfWeight] = useState(false);
  // 催办的
  const [unreadHasMore, setUnReadHasMore] = useState(false);
  const [readHasMore, setReadHasMore] = useState(false);
  const [finishList, setFinishList] = useState<Receiver[]>([]);
  const [unfinishList, setUnFinishList] = useState<Receiver[]>([]);
  const [superviseActiveTab, setSuperviseActiveTab] = useState<string>(readTab.unRead);
  const [loading, setLoading] = useState(true);
  const limit = 20;

  const popoverContent: any = {};

  const currentIsEdit = useCallback(
    (item: any) => {
      if (
        userData?.team?.teamId === item?.teamId &&
        userData?.team?.ddAppId === item?.app &&
        userData?.userId === item?.userId
      ) {
        return true;
      }
    },
    [userData]
  );

  function getSuperviseReadData(offset: number, readFlags: number[]) {
    if (!superviseId) return;
    setLoading(true);
    getSuperviseReceiverList({
      offset,
      limit,
      readFlags,
      superviseId
    })
      .then((res: any[]) => {
        const { receiverList = [] } = res?.[0] || {};
        if (readFlags.indexOf(0) >= 0) {
          if (receiverList.length < limit) {
            setUnReadHasMore(false);
          } else {
            setUnReadHasMore(true);
          }
          setUnFinishList([...unfinishList, ...receiverList]);
        } else {
          if (receiverList.length < limit) {
            setReadHasMore(false);
          } else {
            setReadHasMore(true);
          }
          setFinishList([...finishList, ...receiverList]);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function visibleChange(visible: boolean) {
    if (modalVisible) {
      return;
    }
    if (userCardVisible) {
      return;
    }
    if (userPopover === "supervise") {
      supervisePopoverVisibleChange?.(visible);
      if (visible) {
        getSuperviseReadData(0, [0]);
      } else {
        setUnReadHasMore(false);
        setReadHasMore(false);
        setFinishList([]);
        setUnFinishList([]);
      }
    }
    setVisible(visible);
    setTimeout(() => {
      setAdvanceVisible(false);
    }, 500);
  }
  async function handleRemoveMember(user: WorkUserInfo) {
    if (userPopover === "task" && !isHead) {
      let [res, err] = await checkWhenDeleteTaskExcutors({
        taskId: taskDetail.taskId,
        executors: [user]
      });

      if (err) {
        return message.warn(err);
      }
    }
    setModalVisible(true);
    // 删除提醒
    prompt({
      title: t(`userPopover.remove-${userPopoverText}`), // 要调
      icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
      onOk: () => {
        setModalVisible(false);
        onRemove(
          userPopover === "supervise"
            ? {
                userId: user.userId,
                teamId: user.teamId,
                appId: user.app
              }
            : [
                {
                  userId: user.userId,
                  teamId: user.teamId,
                  app: user.app,
                  taskUserRole: userPopover === "task" ? user.userRole : undefined
                }
              ]
        );
      },
      onCancel: () => {
        setModalVisible(false);
      },
      content: t(`userPopover.remove-${userPopoverText}-desc`).replace("%s", user.realName),
      okText: t("button.ok"),
      cancelText: t("button.cancel")
    });
  }

  function handleAdvanceRecord(user: WorkUserInfo) {
    setAdvanceVisible(true);
    setAdvanceUser(user as any);
  }

  function handleSupervise(advanceUser: WorkUserInfo) {
    const userList: any[] = [];
    userList.push({
      userId: advanceUser?.userId,
      teamId: advanceUser?.teamId,
      appId: advanceUser?.app,
      headImg: advanceUser?.headImg,
      realName: advanceUser?.realName
    });

    openCreateSuperviseModal({
      visible: true,
      createData: {
        id: taskDetail?.taskId,
        title: taskDetail?.title,
        userList,
        from: EsuperviseSourceType.WORK
      }
    });
  }

  function openUserCard(item: WorkUserInfo) {
    if (disableUserCard) {
      return;
    }
    const { userId, teamId, app: appId } = item;
    Bus.emit("app:toggle-user-card-modal:show", {
      visible: true,
      type: UserCardType.User,
      userId,
      appId: userData?.ddAppId || appId || item.appId,
      teamId,
      notPersonalCalendar
    });
  }
  const getProcessStatusTarget = (status: number) => {
    return processStatusOptions.find((item) => item.status === status) || null;
  };

  const getList = (list: any[], noUrge?: boolean) => {
    return list?.map((item) => {
      return (
        // eslint-disable-next-line react/jsx-key
        <div key={item.userId + item.teamId + item.app}>
          <div className="user-status-list-item">
            <Avatar
              src={changeEgovUrl(getHeadImgThumbUrl(item?.imageUrl || item?.headImg, 150, 150))}
              className="avatar"
              name={item.user?.realName || item.realName || ""}
              styleObj={{
                width: "28px",
                height: "28px",
                fontSize: "12px",
                borderRadius: "6px"
              }}
              onClick={() => openUserCard(item)}
            />
            <div className="container">
              <div className="name-content">
                <div className="name">{item.realName}</div>
                {item?.labelInfoList && tagsNode(item?.labelInfoList)}
                {userPopover === "task" &&
                  userPopoverText === "colaborator" &&
                  item.processStatus && (
                    <span>
                      {currentIsEdit(item)
                        ? getProcessStatusTarget(item.processStatus)?.currentLabel || ""
                        : getProcessStatusTarget(item.processStatus)?.label || ""}
                    </span>
                  )}
              </div>
              <div className="btn-content">
                {userPopover === "schedule" &&
                  item.rejectReason &&
                  item.resStatus === ResStatus.Reject && (
                    <Tooltip title={item.rejectReason}>
                      <div className="btn-action">查看原因</div>
                    </Tooltip>
                  )}
                {showAdvance && (
                  <span
                    className="btn-action"
                    clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_collaborator_view_Advancerecord"
                    onClick={(event: any) => {
                      event.preventDefault();
                      event.stopPropagation();
                      handleAdvanceRecord(item);
                    }}
                  >
                    {t("userPopover.advance-record")}
                  </span>
                )}
                {isTaskRelatedPersonnel && !noUrge && taskDetail.taskStatus === 1 && (
                  <span
                    className="btn-action"
                    clstag="pageclick|keycount|xtbg_add_task_1715330698182|26"
                    onClick={(event: any) => {
                      event.preventDefault();
                      event.stopPropagation();
                      handleSupervise(item);
                    }}
                  >
                    催办
                  </span>
                )}
                {!disable && (
                  <div
                    className="btn-action"
                    onClick={(event: any) => {
                      event.preventDefault();
                      event.stopPropagation();
                      switch (userPopover) {
                        case "task":
                          if (mode === "create") {
                            analysisLog(
                              "xtbg_add_task",
                              `xtbg_add_task_createtask_delete${userPopoverText}`
                            );
                          } else if (mode === "edit") {
                            analysisLog(
                              "xtbg_add_task",
                              `xtbg_add_task_taskdetail_delete${userPopoverText}`
                            );
                          }
                          break;
                        case "schedule":
                          if (mode === "create") {
                            analysisLog("xtbg_calhome_1640073907694", "73");
                          } else if (mode === "edit") {
                            analysisLog("xtbg_calhome_1640073907694", "74");
                          }
                          break;
                        case "supervise":
                          if (mode === "create") {
                            analysisLog("xtbg_supervisehome_1681469858167", "9");
                          }
                          break;
                      }
                      handleRemoveMember(item);
                    }}
                  >
                    {t("userPopover.remove")}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    });
  };
  const getEmpty = () => (
    <div className="user-status-list-empty">
      <img src={changeEgovUrl(UserListEmptyImg)} />
      <div className="user-status-list-empty-text">{t(`userPopover.no-${userPopoverText}`)}</div>
    </div>
  );

  popoverContent["getContent"] = () => {
    return (
      <>
        <div className="poppver-content-text">已选择{list?.length}位用户</div>
        <div className="user-status-list" style={{ maxHeight: "calc(100% - 32px)" }}>
          {list?.length > 0 ? getList(list) : getEmpty()}
        </div>
      </>
    );
  };

  popoverContent["getTabs"] = () => {
    return (
      <Tabs>
        {listObj.map((item: any, index: number) => {
          const tablist = item.list || [];
          const title = item.title + ` ${tablist.length}`;
          return (
            <TabPane tab={<span clstag={item.clstag}>{title}</span>} key={index}>
              <div className="user-status-list">
                {tablist.length > 0 ? getList(tablist) : getEmpty()}
              </div>
            </TabPane>
          );
        })}
      </Tabs>
    );
  };

  popoverContent["getTaskAdvanceContent"] = (isTaskDetail?: boolean) => {
    return (
      <div className="user-status-advance-record">
        <div className="user-status-advance-record-title">
          <span
            style={{ cursor: "pointer" }}
            onClick={() => {
              setAdvanceVisible(false);
            }}
          >
            {IconArrowLeft}
          </span>
          <p>
            <i> {advanceUser?.realName}</i>的{t("userPopover.advance-record")}
          </p>
        </div>
        {isTaskDetail ? (
          <div className="personal-situation">
            <div>
              <em>个人状态</em>
              <span
                className={`personal-process-status tag-process-status-${advanceUser?.processStatus}`}
              >
                {PROCESS_STATUS_EXECUTORS[advanceUser?.processStatus as TASK_STATUS]}
              </span>
            </div>
            {advanceUser?.processStatus !== 4 && (
              <div
                className={`process-status-${advanceUser?.processStatus}`}
                style={{
                  width: "100%",
                  display: advanceUser?.processStatus !== 4 ? "flex" : "none",
                  justifyContent: "space-between",
                  marginTop: "15px",
                  alignItems: "center"
                }}
              >
                <em>推进进度</em>
                <Progress
                  percent={advanceUser?.progress}
                  size="small"
                  trailColor="rgba(0,0,0,0.08)"
                  showInfo={false}
                  strokeWidth={4}
                />
                <article
                  style={{
                    color: advanceUser?.progress && advanceUser.progress! > 0 ? "" : "#8F959E"
                  }}
                >
                  {advanceUser?.progress && number2percentum(advanceUser.progress / 100)}
                </article>
              </div>
            )}
          </div>
        ) : (
          <div className="personal-situation">
            <span
              style={{ opacity: advanceUser?.processStatus !== 4 ? "1" : "0" }}
              className={`personal-process-status tag-process-status-${advanceUser?.processStatus}`}
            >
              {PROCESS_STATUS_EXECUTORS[advanceUser?.processStatus as TASK_STATUS]}
            </span>
            <p>
              权重占比：
              {advanceUser?.weight &&
                number2percentum(advanceUser.weight! / taskDetail.totalWeight)}
            </p>
            <div
              className={`process-status-${advanceUser?.processStatus}`}
              style={{
                width: "100%",
                display: advanceUser?.processStatus !== 4 ? "flex" : "none",
                justifyContent: "space-between",
                marginTop: "15px",
                alignItems: "center"
              }}
            >
              <article>
                {advanceUser?.progress && number2percentum(advanceUser.progress / 100)}
              </article>
              <Progress percent={advanceUser?.progress} size="small" showInfo={false} />
            </div>
          </div>
        )}
        <div className="advance-record-wrapper">
          {advanceUser?.processStatus !== 4 ? (
            <AdvanceCom
              className="as-to-someone"
              advanceUser={advanceUser}
              isQueryAuditList={!!isQueryAuditList}
            />
          ) : (
            <div className="non-seen">
              {isTaskDetail ? (
                <>
                  <img style={{ width: 100 }} src={changeEgovUrl(noDataPicture)} alt="暂无数据" />
                  <p>暂无推进记录</p>
                </>
              ) : (
                advanceUser?.realName +
                (getProcessStatusTarget(advanceUser?.processStatus)?.label || "")
              )}
            </div>
          )}
        </div>

        {!isTaskRelatedPersonnel ||
        advanceUser?.processStatus === 2 ||
        taskDetail.taskStatus !== 1 ? null : (
          <div className="go-btn">
            <Button
              type="link"
              clstag="pageclick|keycount|xtbg_add_task|xtbg_add_task_taskdetail_collaborator_view_Advancerecord_urge"
              block
              onClick={() => {
                const userList: any[] = [];
                userList.push({
                  userId: advanceUser?.userId,
                  teamId: advanceUser?.teamId,
                  appId: advanceUser?.app,
                  headImg: advanceUser?.headImg,
                  realName: advanceUser?.realName
                });

                openCreateSuperviseModal({
                  visible: true,
                  createData: {
                    id: taskDetail?.taskId,
                    title: taskDetail?.title,
                    userList,
                    from: EsuperviseSourceType.WORK
                  }
                });
              }}
            >
              {t("userPopover.urge-immediately")}
            </Button>
          </div>
        )}
      </div>
    );
  };

  popoverContent["getTaskContent"] = () => {
    return advanceVisible ? (
      popoverContent["getTaskAdvanceContent"](false)
    ) : (
      <>
        <div className="poppver-content-text">已选择{list?.length}位用户</div>
        <div
          className="user-status-list"
          style={{ maxHeight: `calc(100% - ${visibleWeight ? 76 : 32}px)` }}
        >
          {list?.length > 0 ? getList(list, true) : getEmpty()}
        </div>
        {visibleWeight && (
          <div className="go-btn">
            <Button
              type="link"
              clstag="pageclick|keycount|xtbg_add_task_1715330698182|27"
              onClick={() => {
                setVisibleOfWeight(true);
              }}
            >
              编辑任务权重
            </Button>
          </div>
        )}
      </>
    );
  };

  popoverContent["getTaskDetailContent"] = () => {
    return advanceVisible ? (
      popoverContent["getTaskAdvanceContent"](true)
    ) : (
      <Tabs defaultActiveKey="4" tabBarGutter={0}>
        {[
          PROCESS_STATUS.NOT_VIEWED,
          PROCESS_STATUS.PUSHING,
          PROCESS_STATUS.DIFFICULT,
          PROCESS_STATUS.FINISHED
        ].map((index, i) => {
          const itemList: any = list?.[index];
          return (
            <TabPane
              className="task-process-list-tab"
              tab={
                <span>
                  {PROCESS_STATUS_EXECUTORS[index]} {itemList?.length}
                </span>
              }
              key={index}
            >
              <div className="user-status-list">
                {itemList.length > 0 ? getList(itemList, i === 3) : getEmpty()}
              </div>
            </TabPane>
          );
        })}
      </Tabs>
    );
  };

  popoverContent["getSuperviseContent"] = () => {
    return (
      <Tabs
        defaultActiveKey={readTab.unRead}
        onChange={(activeTab: string) => {
          setSuperviseActiveTab(activeTab);
          if (!finishList.length && activeTab === readTab.Read) {
            getSuperviseReadData(0, [1, 2]);
          } else if (!unfinishList.length && activeTab === readTab.unRead) {
            getSuperviseReadData(0, [0]);
          }
        }}
      >
        <TabPane
          tab={
            <span>
              {t("userPopover.unread")}
              {isNumber(superviseUnFinishCount) ? "(" + superviseUnFinishCount + ")" : ""}
            </span>
          }
          key={readTab.unRead}
        >
          <>
            <div
              className="user-status-list"
              style={{ height: `calc(100% - ${unfinishList.length ? 44 : 0}px)` }}
            >
              {unfinishList.length > 0 ? getList(unfinishList, false) : loading ? null : getEmpty()}
              {unreadHasMore && !loading ? (
                <LoadMore
                  loading={loading}
                  className="load-more"
                  clickHandle={() => {
                    getSuperviseReadData(unfinishList.length, [0]);
                  }}
                />
              ) : null}
            </div>
            {superviseActiveTab === readTab.unRead && unfinishList.length ? (
              <div className="go-somewhere">
                <Button
                  type="link"
                  clstag="pageclick|keycount|xtbg_supervisehome_1681469858167|10"
                  onClick={() => {
                    superviseRepeat?.();
                  }}
                >
                  {t("userPopover.supervise-repeat")}
                </Button>
              </div>
            ) : null}
          </>
        </TabPane>
        <TabPane
          tab={
            <span>
              {t("userPopover.read")}
              {isNumber(superviseFinishCount) ? "(" + superviseFinishCount + ")" : ""}
            </span>
          }
          key={readTab.Read}
        >
          <div className="user-status-list">
            {finishList.length > 0 ? getList(finishList, true) : getEmpty()}
            {readHasMore && !loading ? (
              <LoadMore
                loading={loading}
                className="load-more"
                clickHandle={() => {
                  getSuperviseReadData(finishList.length, [1, 2]);
                }}
              />
            ) : null}
          </div>
        </TabPane>
      </Tabs>
    );
  };

  //  日程详情 getTabs 创建/编辑 getContent
  return (
    <>
      <Popover
        overlayClassName="user-popover-comp"
        trigger="click"
        placement="bottomRight"
        content={popoverContent[popoverName]}
        visible={visible}
        onVisibleChange={visibleChange}
        getPopupContainer={(trigger) => {
          return trigger?.parentElement as HTMLElement;
        }}
        style={{ width: "352px" }}
        destroyTooltipOnHide={true}
      >
        {children}
      </Popover>
      {visibleOfWeight && (
        <WorkUserListWeight
          weightModalConfig={{
            userArr: list,
            close: () => {
              setVisibleOfWeight(false);
            },
            complete: handleTaskMembersWeight,
            isOwner: isHead,
            mode
          }}
        />
      )}
    </>
  );
}
function mapStateToProps({ app }: any) {
  return {
    userCardVisible: app.modals.userCard.visible
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateSuperviseModal: (opt: { visible: boolean; createData: ICreateSuperviseData }) => {
      dispatch({
        type: "supervise/setCreateModalVisible",
        payload: opt
      });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(UserStatusListPopover);
